import React from "react"

import type { FlexProps, ThemingProps } from "@chakra-ui/react"
import { Flex, useStyleConfig } from "@chakra-ui/react"

export const Card = (props: FlexProps & ThemingProps) => {
  const { children, ...rest } = props
  const styles = useStyleConfig("Card", props)

  return (
    <Flex justify="center" align="center" __css={styles} {...rest}>
      {children}
    </Flex>
  )
}
